import React from "react";
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import RevenueManagerComponent from "../../components/dashboard/RevenueManager";

export default function RevenueManager() {
  return (
    <DashboardLayout>
      <RevenueManagerComponent />
    </DashboardLayout>
  );
}
